import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Img from "./image.svg";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Preloader = /*#__PURE__*/function (_Component) {
  _inherits(Preloader, _Component);
  var _super = _createSuper(Preloader);
  function Preloader() {
    _classCallCheck(this, Preloader);
    return _super.apply(this, arguments);
  }
  _createClass(Preloader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        size = _this$props.size,
        className = _this$props.className,
        isStyled = _this$props.isStyled;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(isStyled && 'component', className),
        "data-t-id": "components-Preloader"
      }, /*#__PURE__*/React.createElement(Img, {
        className: cx('image'),
        height: size,
        width: size
      }));
    }
  }]);
  return Preloader;
}(Component);
_defineProperty(Preloader, "defaultProps", {
  size: '48',
  isStyled: true
});
export { Preloader as default };
Preloader.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  isStyled: PropTypes.bool,
  size: PropTypes.string
} : {};